<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body">
      <div class="block">
        <Row class="margin-bottom-20">
          <Col span="12">
            <Input search enter-button placeholder="输入结构件名称、编号或者客户名称进行查询" v-model="keywords" @on-search="handleSearch" style="width: 500px;" />
          </Col>
        </Row>
        <div class="actions text-align-right">
          <Button :to="{ name: 'menu.mechanical_part.new' }" type="primary" size="large">{{ $t('mechanical.button.new_mechanical') }}</Button>
        </div>

        <div style="overflow-x: auto">
          <div style="overflow-x: auto">
            <PaginatedTable ref="mechanicalPartTable"
                            :url="queryUrl"
                            :init-options="options"
                            :columns="columns"
                            :show-action-column="true"
                            @on-row-edit="handleRowEdit"></PaginatedTable>
          </div>
        </div>

        <div class="actions text-align-right">
          <Button :to="{ name: 'menu.mechanical_part.new' }" type="primary" size="large">{{ $t('mechanical.button.new_mechanical') }}</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginatedTable from '@/components/tables/paginated-table'

export default {
  name: 'MechanicalPartList',
  components: {
    PaginatedTable
  },
  data () {
    return {
      queryUrl: '/parts/mechanical-part',
      columns: [
        {
          title: '#',
          type: 'index',
          width: 40,
          align: 'center'
        },
        {
          title: 'Part number',
          key: 'part_identity',
          width: 140,
          render: (h, params) => {
            return h('span', params.row.part_identity?.part_number)
          }
        },
        {
          key: 'name',
          title: 'Name'
        },
        {
          key: 'chinese_name',
          title: 'Chinese name'
        },
        {
          key: 'specification',
          title: 'Specification'
        }
      ],
      keywords: '',
      options: {}
    }
  },
  computed: {
    pageTitle () {
      document.title = this.$t('mechanical.list.title')
      return document.title
    }
  },
  methods: {
    handleRowEdit: function (row, rowIndex) {
      this.$router.push({ name: 'menu.mechanical_part.edit', params: { partId: row.id } })
    },
    handleSearch (value) {
      if (value.trim()) {
        if (this.options.q) {
          this.options.q = encodeURIComponent(value)
        } else {
          this.$set(this.options, 'q', encodeURIComponent(value))
        }
      } else {
        if (this.options.q) { this.options.q = '' }
        this.$refs['mechanicalPartTable'].refresh()
      }
    }
  }
}
</script>

<style scoped>

</style>
